import { useTranslations } from "next-intl";
import { useCallback, useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { Input } from "@/common/components/form/input";
import { debounce } from "@/common/utils";

export const SequentialNumberingForm = ({
  setSequentialNumbering,
  defaultValue,
}: {
  setSequentialNumbering: (value: number) => void;
  defaultValue?: number;
}) => {
  const t = useTranslations("custom-attributes-forms");
  const {
    register,
    getValues,
    setValue,
    resetField,
    formState: { errors },
  } = useFormContext<{ sequentialNumberingValue: number }>();

  const debouncedOnChange = useCallback(debounce(setSequentialNumbering, 1500), []);

  const handleChange = () => {
    const sequentialNumbering = getValues("sequentialNumberingValue");
    debouncedOnChange(sequentialNumbering);
  };

  useEffect(() => {
    if (defaultValue) {
      setValue("sequentialNumberingValue", defaultValue);
    } else {
      resetField("sequentialNumberingValue");
    }
  }, [defaultValue, resetField, setValue]);

  return (
    <div className="flex items-center">
      <span className="mr-5 flex items-center text-left">
        {t("text-sequential-numbering-start")}
      </span>
      <Input
        required
        variant="solid"
        type="number"
        {...register("sequentialNumberingValue", {
          valueAsNumber: true,
          onChange: handleChange,
          validate: {
            isPositive: (v) => (v && Number(v) >= 0) || t("error-positive"),
          },
        })}
        error={errors.sequentialNumberingValue && errors.sequentialNumberingValue.message!}
        className="w-[80px] md:w-[120px]"
        inputClassName="!md:text-base h-12 !text-sm"
        labelClassName="!text-xs !leading-none !font-normal"
      />
    </div>
  );
};
